import { call, put, takeEvery, delay } from 'redux-saga/effects'
import { get, post } from '@modul-connect/shared/utils/ajax'

function* fetchWorkshops() {
  const workshops = yield call(get, '/workshop/v3')

  if(workshops && workshops.status === 'ok') {
      const data = workshops.data;
      yield put({ type: 'WORKSHOPS_FETCHED', data, total: data.length })
  }
  else {
    yield put({ type: 'FETCHING_WORKSHOPS_FAILED' })
  }
}

function* fetchWorkshop({ id, rowsPerPage, page, sort, searchStr }) {
  let url = `/workshop/${id}`
  url += '?count=' + rowsPerPage
  url += '&page=' + page
  url += '&sortby=' + sort

  const response = yield call(get, url)

  switch(response?.status) {
    case 'ok':
      if(response.data) {
        yield put({ type: 'WORKSHOP_FETCHED',
          data: {
            ...response.data,
            workshopId: id
          }
        })
      }
      return
    case 'not_found':
    case 'no_content':
        yield put({ type: 'WORKSHOP_FETCHED',
          data: {
            ...response.data,
            workshopId: id
          }
        })
        console.warn('workshop not found')
        return
    default:
      yield put({ type: 'FETCHING_WORKSHOP_FAILED', data: {workshopId: id }})
      return
  }
}

function* fetchWorkshopV2({ id }) {
  const url = `/workshop/v2/${id}`

  const response = yield call(get, url)

  switch(response?.status) {
    case 'ok':
      if(response.data) {
        yield put({ type: 'WORKSHOP_FETCHED',
          data: {
            ...response.data,
            workshopId: id
          }
        })
      }
      return
    case 'not_found':
    case 'no_content':
        yield put({ type: 'WORKSHOP_FETCHED',
          data: {
            ...response.data,
            workshopId: id
          }
        })
        console.warn('workshop not found')
        return
    default:
      yield put({ type: 'FETCHING_WORKSHOP_FAILED', data: {workshopId: id }})
      return
  }
}

function* addWorkshop({ name, parentId }) {
  const command = {
    name,
    parentId,
    isWorkshop: parentId?.length ? false : true
  }

  const result = yield call(post, '/cmd/customer/addorganisation', { body: JSON.stringify(command) })

  if (result && result.status && result.status === 'ok') {
    yield delay(2000) // server needs a bit more time

    yield put({ type: 'WORKSHOP_ADDED', data: { ...result.data, parentId } })
  }
  else {
    yield put({ type: 'ADDING_WORKSHOP_FAILED' })
  }
}

function* removeWorkshop({ id }) {
  const result = yield call(post, '/cmd/customer/removeorganisation', { body: JSON.stringify({ id: `organisation/${id}` }) })

   if (result && result.status && result.status === 'ok') {
    yield delay(2000) // server needs a bit more time

    yield put({ type: 'WORKSHOP_REMOVED', data: { id } })
   }
  else
    yield put({ type: 'REMOVING_WORKSHOP_FAILED', data: { id } })
}

function* renameWorkshop({ id, newName }) {
  const result = yield call(post, '/cmd/customer/renameorganisation', { body: JSON.stringify({ id: `organisation/${id}`, newName }) })

  if (result && result.status && result.status === 'ok') {
    yield delay(2000) // server needs a bit more time

    yield put({ type: 'WORKSHOP_RENAMED', data: { id, newName } })
  }
  else
    yield put({ type: 'RENAMING_WORKSHOP_FAILED', data: { id, newName } })
}

export function* workhsopSagas() {
  yield takeEvery('FETCH_WORKSHOPS', fetchWorkshops)
  yield takeEvery('FETCH_WORKSHOP', fetchWorkshop)
  yield takeEvery('FETCH_WORKSHOP_V2', fetchWorkshopV2)
  yield takeEvery('ADD_WORKSHOP', addWorkshop)
  yield takeEvery('REMOVE_WORKSHOP', removeWorkshop)
  yield takeEvery('RENAME_WORKSHOP', renameWorkshop)
}